import { Flex } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text, Title } from 'components/mvp-typography';
import { useHistory } from 'react-router-dom';
import { ClinicianRoutePrefix } from 'routes';

export default function BillingPage() {
  const history = useHistory();
  const handleFinish = () => {
    // TODO: Navigate to the dashboard or home page
    console.log('Finished onboarding!');
    history.push(ClinicianRoutePrefix); // Example navigation to clinician home
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        gap: 24
      }}
    >
      <Title>Billing</Title>
      <Flex vertical gap={16} style={{ maxWidth: '50%'}}>
        <Text>Thanks for joining ConcussionRx!</Text>
        <Text>We recently launched our concussion care product to the public, and are looking forward to seeing how you like it. All we ask is that you provide your honest feedback in our product surveys, so we can learn how to improve our offering.</Text>
        <Text>Once you are in the platform, a ConcussionRx team member will be in touch to complete the setup and billing process for Baseline and Post-Injury assessments. </Text>
        <Text>We are looking forward to changing the face of concussion care and brain health, together!</Text>
        <div style={{ marginTop: '20px' }}>
          <BaseButton type="primary" onClick={handleFinish}>
            Finish
          </BaseButton>
        </div>
      </Flex>
    </div>
  );
}
